import * as z from "zod";

export const getReturnsStuckHubspotDealsInputSchema = z.object({
  /** Deals untouched for at least this many days. Default 14. */
  stuckDaysThreshold: z.number().int().min(1).max(365).default(14),
  /** Max rows to return. Default 100. */
  limit: z.number().int().min(1).max(500).default(100),
});
export type GetReturnsStuckHubspotDealsInput = z.infer<
  typeof getReturnsStuckHubspotDealsInputSchema
>;

const stuckDealSchema = z.object({
  hubspotId: z.string(),
  dealName: z.string().nullable(),
  companyName: z.string().nullable(),
  stageLabel: z.string(),
  ownerName: z.string().nullable(),
  amountCents: z.string().nullable(),
  daysSinceLastModified: z.number().int().min(0),
});
export type ReturnsStuckHubspotDeal = z.infer<typeof stuckDealSchema>;

export const getReturnsStuckHubspotDealsOutputSchema = z.object({
  deals: z.array(stuckDealSchema),
  totalStuck: z.number().int().min(0),
});
export type GetReturnsStuckHubspotDealsOutput = z.infer<
  typeof getReturnsStuckHubspotDealsOutputSchema
>;

export const getReturnsStuckHubspotDeals = {
  name: "getReturnsStuckHubspotDeals" as const,
  input: getReturnsStuckHubspotDealsInputSchema,
  output: getReturnsStuckHubspotDealsOutputSchema,
};
